import { issueFinished } from './successNotification.js';


/**
 * @param heftausgabe_id
 * @param anzahl_ungelesen
 */
export function updateIssueTeaser(heftausgabe_id, anzahl_ungelesen) {
    const teaser = document.getElementById('heftausgabe_teaser_' + heftausgabe_id);
    if (!teaser) {
        return;
    }

    const badge = teaser.querySelector('#ungelesene_heftausgabe_teaser_' + heftausgabe_id);
    if (!badge) {
        return;
    }

    if (anzahl_ungelesen !== 0) {
        // Ungelesene Artikel vorhanden: Dot anzeigen
        badge.innerHTML = '<span class="w-1 h-1 rounded-full bg-primary-on-surface"></span>';
    } else {
        // Alle gelesen: Badge leer lassen
        badge.innerHTML = '';
    }
}


/**
 * @param heftausgabe_id
 * @param ungelesene_artikel
 */
export function updateIssueFilter(heftausgabe_id, ungelesene_artikel) {
    const element_anzahl_ungelesene = document.getElementById('ausgabe_ungelesene_' + heftausgabe_id);
    // Zahl durch Checkbox austauschen
    if (ungelesene_artikel === 0 && element_anzahl_ungelesene) {
        element_anzahl_ungelesene.textContent = '';
        element_anzahl_ungelesene.classList.add('before:content-checkmark');
        element_anzahl_ungelesene.classList.add('before:font-icomoon');
        element_anzahl_ungelesene.classList.add('before:text-xl');
        element_anzahl_ungelesene.classList.add('before:text-neutral-subtle');
        element_anzahl_ungelesene.classList.add('before:leading-none');
        element_anzahl_ungelesene.classList.add('before:relative');
        element_anzahl_ungelesene.classList.add('before:-top-[2px]');
    } else if (element_anzahl_ungelesene) {
        element_anzahl_ungelesene.textContent = ungelesene_artikel;
        // Es wurde gerade ein Artikel als ungelesen markiert
        element_anzahl_ungelesene.classList.remove('before:content-checkmark');
        element_anzahl_ungelesene.classList.remove('before:font-icomoon');
        element_anzahl_ungelesene.classList.remove('before:text-xl');
        element_anzahl_ungelesene.classList.remove('before:text-neutral-subtle');
        element_anzahl_ungelesene.classList.remove('before:leading-none');
        element_anzahl_ungelesene.classList.remove('before:relative');
        element_anzahl_ungelesene.classList.remove('before:-top-[2px]');

    }

    // Gleiches nochmal, falls es sich um aktuell ausgewaehltes Jahr handelt - braucht andere Klassen
    const element_anzahl_ungelesene_ausgewaehlt = document.getElementById('ausgabe_ungelesene_ausgewaehlt_' + heftausgabe_id);
    // Zahl durch Checkbox austauschen
    if (ungelesene_artikel === 0 && element_anzahl_ungelesene_ausgewaehlt) {
        element_anzahl_ungelesene_ausgewaehlt.textContent = '';
        element_anzahl_ungelesene_ausgewaehlt.classList.add('before:content-checkmark');
        element_anzahl_ungelesene_ausgewaehlt.classList.add('before:font-icomoon');
        element_anzahl_ungelesene_ausgewaehlt.classList.add('before:text-xl');
        element_anzahl_ungelesene_ausgewaehlt.classList.add('before:text-neutral-subtle');
        element_anzahl_ungelesene_ausgewaehlt.classList.add('before:leading-none');
        element_anzahl_ungelesene_ausgewaehlt.classList.add('before:relative');
        element_anzahl_ungelesene_ausgewaehlt.classList.add('before:top-[2px]');

        issueFinished();
    } else if (element_anzahl_ungelesene_ausgewaehlt) {
        element_anzahl_ungelesene_ausgewaehlt.textContent = ungelesene_artikel;
        // Es wurde gerade ein Artikel als ungelesen markiert
        element_anzahl_ungelesene_ausgewaehlt.classList.remove('before:content-checkmark');
        element_anzahl_ungelesene_ausgewaehlt.classList.remove('before:font-icomoon');
        element_anzahl_ungelesene_ausgewaehlt.classList.remove('before:text-xl');
        element_anzahl_ungelesene_ausgewaehlt.classList.remove('before:text-neutral-subtle');
        element_anzahl_ungelesene_ausgewaehlt.classList.remove('before:leading-none');
        element_anzahl_ungelesene_ausgewaehlt.classList.remove('before:relative');
        element_anzahl_ungelesene_ausgewaehlt.classList.remove('before:top-[2px]');
    }
}

/**
 * @param {HTMLElement} status
 * @param {number} geleseneArtikel
 * @param {number} artikelAnzahl
 */
export function updateIssueStatus(status, geleseneArtikel, artikelAnzahl) {
    const icon = status.querySelector('[data-issue-status-icon]');
    const text = status.querySelector('[data-issue-status-text]');

    if (!icon || !text) {
        return;
    }

    if (artikelAnzahl === 0) {
        icon.classList.add('hidden');
        text.textContent = 'Keine Artikel verfügbar';
        return;
    }

    if (geleseneArtikel === artikelAnzahl) {
        icon.classList.remove('hidden');
        text.textContent = 'Ausgabe abgeschlossen';
        return;
    }

    icon.classList.add('hidden');
    text.textContent = `${geleseneArtikel} von ${artikelAnzahl} ${artikelAnzahl === 1 ? 'Artikel' : 'Artikeln'} gelesen`;
}


/**
 * @param filter_element
 * @param anzahl_ungelesene
 */
export function updateYearFilter(filter_element, anzahl_ungelesene) {
    if (!filter_element) {
        return;
    }

    if (anzahl_ungelesene === 0) {
        filter_element.style.display = 'none';
    } else {
        filter_element.style.display = '';
    }
}


/**
 * @param filter_element
 * @param anzahl_ungelesene
 */
export function updateSelectedYearFilter(filter_element, anzahl_ungelesene) {
    if (!filter_element) {
        return;
    }

    if (anzahl_ungelesene === 0) {
        filter_element.style.display = 'none';
        issueFinished();
    } else {
        filter_element.style.display = '';
    }
}


/**
 * @param ausgabe_id
 * @param ungelesene_artikel
 */
export function updateNewsletterIssueFilter(ausgabe_id, ungelesene_artikel) {
    const element_anzahl_ungelesene = document.getElementById('newsletterausgabe-ungelesene-' + ausgabe_id);

    // Zahl durch Checkbox austauschen
    if (ungelesene_artikel === 0 && element_anzahl_ungelesene) {
        element_anzahl_ungelesene.textContent = '';
        element_anzahl_ungelesene.classList.add('before:content-checkmark');
        element_anzahl_ungelesene.classList.add('before:font-icomoon');
        element_anzahl_ungelesene.classList.add('before:text-xl');
        element_anzahl_ungelesene.classList.add('before:text-neutral-subtle');
        element_anzahl_ungelesene.classList.add('before:leading-none');
        element_anzahl_ungelesene.classList.add('before:relative');
        element_anzahl_ungelesene.classList.add('before:-top-[2px]');
    } else if (element_anzahl_ungelesene) {
        element_anzahl_ungelesene.textContent = ungelesene_artikel;
        // Es wurde gerade ein Artikel als ungelesen markiert
        element_anzahl_ungelesene.classList.remove('before:content-checkmark');
        element_anzahl_ungelesene.classList.remove('before:font-icomoon');
        element_anzahl_ungelesene.classList.remove('before:text-xl');
        element_anzahl_ungelesene.classList.remove('before:text-neutral-subtle');
        element_anzahl_ungelesene.classList.remove('before:leading-none');
        element_anzahl_ungelesene.classList.remove('before:relative');
        element_anzahl_ungelesene.classList.remove('before:-top-[2px]');
    }

    // Gleiches nochmal, falls es sich um aktuell ausgewaehltes Jahr handelt - braucht andere Klassen
    const element_anzahl_ungelesene_ausgewaehlt = document.getElementById('newsletterausgabe-ungelesene-ausgewaehlt-' + ausgabe_id);
    // Zahl durch Checkbox austauschen
    if (ungelesene_artikel === 0 && element_anzahl_ungelesene_ausgewaehlt) {
        element_anzahl_ungelesene_ausgewaehlt.textContent = '';
        element_anzahl_ungelesene_ausgewaehlt.classList.add('before:content-checkmark');
        element_anzahl_ungelesene_ausgewaehlt.classList.add('before:font-icomoon');
        element_anzahl_ungelesene_ausgewaehlt.classList.add('before:text-xl');
        element_anzahl_ungelesene_ausgewaehlt.classList.add('before:text-neutral-subtle');
        element_anzahl_ungelesene_ausgewaehlt.classList.add('before:leading-none');
        element_anzahl_ungelesene_ausgewaehlt.classList.add('before:relative');
        element_anzahl_ungelesene_ausgewaehlt.classList.add('before:top-[2px]');

        issueFinished();
    } else if (element_anzahl_ungelesene_ausgewaehlt) {
        element_anzahl_ungelesene_ausgewaehlt.textContent = ungelesene_artikel;
        // Es wurde gerade ein Artikel als ungelesen markiert
        element_anzahl_ungelesene_ausgewaehlt.classList.remove('before:content-checkmark');
        element_anzahl_ungelesene_ausgewaehlt.classList.remove('before:font-icomoon');
        element_anzahl_ungelesene_ausgewaehlt.classList.remove('before:text-xl');
        element_anzahl_ungelesene_ausgewaehlt.classList.remove('before:text-neutral-subtle');
        element_anzahl_ungelesene_ausgewaehlt.classList.remove('before:leading-none');
        element_anzahl_ungelesene_ausgewaehlt.classList.remove('before:relative');
        element_anzahl_ungelesene_ausgewaehlt.classList.remove('before:top-[2px]');
    }
}


/**
 * @param newsletter_id
 * @param anzahl_ungelesen
 */
export function updateNewsletterIssueTeaser(newsletter_id, anzahl_ungelesen) {
    const teaser = document.getElementById('newsletterausgabe_teaser_' + newsletter_id);
    if (!teaser) {
        return;
    }

    const unreadDotContainer = teaser.querySelector('#ungelesene_newsletterausgabe_teaser_' + newsletter_id);

    if (!unreadDotContainer) {
        return;
    }

    if (anzahl_ungelesen !== 0) {
        unreadDotContainer.innerHTML = '<span class="w-1 h-1 rounded-full bg-primary-on-surface"></span>';
    } else {
        unreadDotContainer.innerHTML = '';
    }
}
